module.exports = __webpack_public_path__ + "img/progress_037.158de87b.png";